import Request from './index.js'
import md5 from '../utils/md5.js'
import comUtils from '../utils/ComUtils.js'
import aesEncrypt from '../utils/aes_endecrypt.js'
let request = new Request().http;

function get(url, data) {
	//获取token
	let header = {
		dfgsessionkey: comUtils.getUrlPar("dfgtoken")
	}
	return request({
		url: url,
		method: 'GET',
		data: data,
		header: header
	})
}

function post(url, data) {
	//获取token
	let keysList = Object.keys(data);
	let enstr = "";
	//获取openid
	let openid = uni.getStorageSync('smsopenid');
	var curTime = new Date();
	var diyDate = new Date(curTime.setMinutes(curTime.getMinutes() + 10));
	let en = {
		OpenId: openid,
		ExpirationTime: comUtils.formatDate(diyDate, 'yyyy-MM-dd hh:mm:ss')
	};
	enstr = aesEncrypt.aes_encrypt(JSON.stringify(en));
	let header = {
		operatertoken: enstr
	}
	return request({
		url: url,
		method: 'POST',
		data: data,
		header: header,
	})
}


let api = {
	post: (url, data) => post(url, data),
	get: (url, data) => get(url, data)
}

export default api;